/**
 * This helper module contains common getters that can be used across most entity types, including
 * system (accounts, productions, etc.) and data entry entity types (APs, JEs, PCs, POs, and Checks).
 * Each getter must receive the module name as its first argument.
 */

const getters = {
  getAllOfType: (state, rootState) => (type) => {
    return state.cache ? Object.values(state.cache).map(v => Object.assign({}, v)) : []
  }
}

export default {
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/helpers/getters.js